<div class="app-side-bar-search-expandable-block">
  <div class="app-side-bar-search-expandable-block-header">
    <h3 class="app-side-bar-search-expandable-block-header-title">{{title}}</h3>
    <fw-icon color="slate" class="app-side-bar-search-expandable-block-header-icon" [class.collapsed]="!isExpanded"
      (click)="isExpanded = !isExpanded" size="medium">chevron-up</fw-icon>
  </div>
  <ng-container *ngIf="isExpanded">
    <div @toggle>
      <ng-content></ng-content>
    </div>
  </ng-container>
</div>
